export const UltimateMember = (function () {
	'use strict';

	function init() {
		// Listen for click on Ultimate Member registration submit button
		document.addEventListener('click', function(event) {
			if (event.target.matches('.um-register #um-submit-btn')) {
				// Button clicked - set cookie before form submission
				const form = event.target.closest('form');
				const emailField = form.querySelector('#user_email-481');
				
				if (emailField && emailField.value) {
					// Set cookie with 5-minute expiration
					document.cookie = `um_registration_email=${encodeURIComponent(emailField.value)}; max-age=300; path=/`;
				}
			}
		});
	}

	return {
		init: init,
	};
})();
